import { observer } from "mobx-react-lite";

import { isDefaultData, isWaitingForData } from "../../common/utils/asyncDataUtils";

import subscriptionStore from "../../stores/subscriptionStore";

import Loading from "../Loading";
import ShortcutChangeSubscription from "./ShortcutChangeSubscription";
import ShortcutFavoritesToCart from "./ShortcutFavoritesToCart";
import ShortcutNewSubscription from "./ShortcutNewSubscription";

const ShortcutBoxes = () => {
   if (isDefaultData(subscriptionStore.subscriptionsList) || isWaitingForData(subscriptionStore.subscriptionsList)) {
      return <Loading label="Laster informasjon om abonnement" />;
   }

   const hasSubscriptions = subscriptionStore.subscriptionsList.data.length > 0;

   return (
      <div className="flex h-full flex-col">
         <h3 className="mb-6">Snarveier</h3>
         <div className="mb-2 flex flex-col items-stretch md:flex-row">
            {hasSubscriptions ? <ShortcutChangeSubscription /> : <ShortcutNewSubscription />}
            <ShortcutFavoritesToCart />
         </div>
      </div>
   );
};

export default observer(ShortcutBoxes);
